<div class="row">
	<div class="table-responsive">
		<table class="table table-borderless mb-0" style="width: fit-content">
			<tbody>
				<tr style="width: 50%">
					<th class="ps-0">Numéro :</th>
					<td class="text-muted">{{ id }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Projet :</th>
					<td class="text-muted">{{ project }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Date du bon de sortie :</th>
					<td class="text-muted">{{ date }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Magasinier :</th>
					<td class="text-muted">{{ magasinier }}</td>
				</tr>

				<tr style="width: 50%">
					<th class="ps-0">Commantaire du bon de sortie :</th>
					<td class="text-muted">
						@if (commantaire) {
							{{ commantaire }}
						} @else {
							Aucun commentaire saisi
						}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
